var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"title":_vm.caller},on:{"ok":_vm.handleOk},model:{value:(_vm.ringVisible),callback:function ($$v) {_vm.ringVisible=$$v},expression:"ringVisible"}},[_c('p',[_vm._v("救援电话呼入，是否立即接单")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }